<div class="toast-container">
  <app-custom-toast
    *ngFor="let toast of toasts"
    [toast]="toast"
    (close)="onToastClose($event)">
  </app-custom-toast>
</div>
